import {shallowEqual, useSelector} from "react-redux";

const useShallowSelector = selector => {
    return useSelector(selector, shallowEqual);
};

export default useShallowSelector;
